const formOptions = {
  eventFormats: [
    {
      label: "Virtual",
      value: "Virtual",
    },
    {
      label: "In Person",
      value: "In Person",
    },
    {
      label: "Hybrid",
      value: "Hybrid",
    },
  ],
  eventTypes: [
    {
      label: "Off-site",
      value: "Off-site",
    },
    {
      label: "On-site",
      value: "On-site",
    },
  ],
  offices: [
    {
      label: "Boston",
      value: "Boston",
    },
    {
      label: "Hartford",
      value: "Hartford",
    },
    {
      label: "Boston & Hartford (New England)",
      value: "Boston & Hartford (New England)",
    },
  ],
  dressCode: [
    {
      label: "Business",
      value: "Business",
    },
    {
      label: "Business Casual",
      value: "Business Casual",
    },
    {
      label: "Casual",
      value: "Casual",
    },
  ],
  eventTags: [
    { label: "Aspire", value: "Aspire" },
    { label: "Corporate Citizenship", value: "Corporate Citizenship" },
    { label: "Community of Practice (CoP)", value: "Community of Practice (CoP)" },
    { label: "Learning", value: "Learning" },
    { label: "Market-Wide", value: "Market-Wide" },
    { label: "Military", value: "Military" },
    { label: "Partners for Good", value: "Partners for Good" },
    { label: "Prism", value: "Prism" },
    { label: "REACH", value: "REACH" },
    { label: "Slalom Women", value: "Slalom Women" },
    { label: "Social", value: "Social" },
    { label: "Unidos", value: "Unidos" },
    { label: "Wellness", value: "Wellness" },
    { label: "Other", value: "Other" },
  ],
  distributionList: [
    {
      label: "New England - All (newenglandall@slalom.com)",
      value: "newenglandall@slalom.com",
      prod: true,
    },
    {
      label: "New England Events (newenglandevents@slalom.com) (Selecting this option will create your event without notifying the market)",
      value: "newenglandevents@slalom.com",
      prod: true,
    },
    {
      label: "Boston All (boston-all@slalom.com)",
      value: "boston-all@slalom.com",
      prod: true,
    },
        {
      label: "Hartford All (hartford-all@slalom.com) ",
      value: "hartford-all@slalom.com",
      prod: true,
    },
    {
      label: "Test Distribution List 1 (GatherTestingDL@slalom.com)",
      value: "GatherTestingDL@slalom.com",
      prod: false,
    },
    {
      label: "Test Distribution List 2 (GatherTestTwo@slalom.com)",
      value: "GatherTestTwo@slalom.com",
      prod: false,
    },
  ],
};

export default formOptions;
